import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Droplets, Flame, CloudLightning, Home, Wind, Waves } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  const icons = [Droplets, Flame, CloudLightning, Home, Wind, Waves];
  return <section id="services" className="py-24 relative overflow-hidden" data-id="element-227">
      <div className="absolute inset-0 bg-cover bg-center opacity-15" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/tacb6dbM4roumakSk7F724/causes-of-house-fires-300x200.jpg")'
    }} data-id="element-228" />
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-900/95 to-gray-900" data-id="element-229" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-231">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-red font-bold tracking-wider uppercase mb-2" data-id="element-232">
            {t.services.tag}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-233">
            {t.services.title}
          </motion.h3>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-300" data-id="element-234">
            {t.services.desc}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-235">
          {t.services.items.map((service, index) => {
          const Icon = icons[index];
          const slugs = ['water-damage', 'fire-smoke-damage', 'storm-hurricane', 'roof-claims', 'mold-damage', 'flood-claims'];
          const slug = slugs[index];
          const cardImages = ['https://cdn.magicpatterns.com/uploads/1knTMdXWd67U1nkoMsFRAi/Orca-Water-Damage-Restoration-1536x861.jpg', 'https://cdn.magicpatterns.com/uploads/o3yBkfMfYaWJet3qzrwMja/causes-of-house-fires-300x200.jpg', 'https://cdn.magicpatterns.com/uploads/eYQHw742EJTcYLmEaFcsRY/hurricane-season-mid-year-outlook-stage.webp', 'https://cdn.magicpatterns.com/uploads/gSGcZoZKqem1UgjHfg3TaG/roof-storm-damage-and-what-to-do-next.webp', 'https://cdn.magicpatterns.com/uploads/i8ZojYGU36eZcmg9oe9Khx/Mold-Damage-Clean-Up-1.jpg', 'https://cdn.magicpatterns.com/uploads/sZxN5TM9oRwy2QRwLj7j7D/flood-damage-to-home-in-metairie-kenner-harahan.jpg.webp'];
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-236">
                <Link to={`/services/${slug}`} className="relative overflow-hidden border border-white/10 rounded-sm shadow-lg hover:-translate-y-2 transition-all duration-300 group block h-full flex flex-col bg-gray-900/80" data-id="element-237">
                  {/* Visible Image Section */}
                  <div className="relative h-48 overflow-hidden" data-id="element-238">
                    <div className="absolute inset-0 bg-cover bg-center group-hover:scale-110 transition-transform duration-700" style={{
                  backgroundImage: `url("${cardImages[index]}")`
                }} data-id="element-239" />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/30 to-transparent" data-id="element-240" />
                    <div className="absolute top-4 left-4 w-12 h-12 bg-brand-red/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg" data-id="element-241">
                      <Icon className="text-white" size={24} data-id="element-242" />
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-6 flex flex-col flex-grow border-b-4 border-brand-red" data-id="element-243">
                    <h4 className="text-xl font-bold text-white mb-3" data-id="element-244">
                      {service.title}
                    </h4>
                    <p className="text-gray-400 leading-relaxed text-sm flex-grow" data-id="element-245">
                      {service.description || service.desc}
                    </p>
                    <div className="mt-5 inline-flex items-center gap-2 text-brand-gold font-bold text-sm uppercase tracking-wider group-hover:gap-3 transition-all" data-id="element-246">
                      {t.process.learnMore}{' '}
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-247">
                        <path d="M5 12h14" data-id="element-248" />
                        <path d="m12 5 7 7-7 7" data-id="element-249" />
                      </svg>
                    </div>
                  </div>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}